export const identity = (_) => _;
//# sourceMappingURL=identity.js.map